// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.header[data-v-7c7a7914] {\n  display: flex;\n  justify-content: flex-start;\n  padding: 20px 130px\n}\n.breadcrumb[data-v-7c7a7914] {\n  font-size: 20px;\n[data-v-7c7a7914] .is-link {\n    color: white;\n}\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
